<template>
  <div
    class="dropdown-container"
    :class="[options.containerClass ? options.containerClass : '', !showMainBorder ? 'open' : '']"
  >
    <div class="dropdown-initial" @click="toggleDropdown()">
      <slot name="leftIcon">
         
      </slot>
      <div class="dropdown-btn-icon" v-if="options.singleIcon" :class="{active: isDropdownOpen}">
        <slot name="icon">
         <FilterOnColumnsSVG />
        </slot>
      </div>
      <span v-if="options.singleIcon != true">{{
        options.initial
          ? options.selectAllChoice && isAllChecked()
            ? toLocal(options.selectAllChoice)
            : toLocal(options.initial)
          : toLocal("generic.choose")
      }}</span>
      <span
        :class="[{ reverse: isDropdownOpen }, { initial: !isDropdownOpen }]"
        v-if="options.open != true && options.singleIcon != true"
      >
        <slot name="arrow">
          <ArrowDownSVG class="white" />
        </slot>
      </span>
      <span class="closeBtn" v-if="options.closeBtn" @click="closeDropdown"
        ><CrossSVG
      /></span>
    </div>

    <transition name="slide">
     <div 
      class="dropdown-header-container"
      :class="{'closing': !isDropdownListOpen}"
      v-if="options.type && options.type == 'groups-supervisor' && isDropdownOpen"
     >
        <div class="dropdown-initial" @click="toggleDropdown()">
          <slot name="leftIcon">
            
          </slot>
          <div class="dropdown-btn-icon" v-if="options.singleIcon" :class="{active: isDropdownOpen}">
            <slot name="icon">
            <FilterOnColumnsSVG />
            </slot>
          </div>
          <span v-if="options.singleIcon != true">{{
            options.initial
              ? options.selectAllChoice && isAllChecked()
                ? toLocal(options.selectAllChoice)
                : toLocal(options.initial)
              : toLocal("generic.choose")
          }}</span>
          <span
            :class="[{ reverse: isDropdownOpen }, { initial: !isDropdownOpen }]"
            v-if="options.open != true && options.singleIcon != true"
          >
            <slot name="arrow">
              <ArrowDownSVG class="white" />
            </slot>
          </span>
          <span class="closeBtn" v-if="options.closeBtn" @click="closeDropdown"
            ><CrossSVG
          /></span>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        v-click-outside-3="closeDropdown"
        class="dropdown-extended"
        :class="{
          left: options.left, 
          dynamic: options.valueWidthType && options.valueWidthType =='dynamic',
          top: true
        }"
        ref="dropdownExtended"
        v-if="isDropdownListOpen"
        :style="[{
          width: options.customDDWidth ? options.customDDWidth : '120%',
          'max-width': options.customDDMaxWidth ? options.customDDMaxWidth : '',
          'min-width': options.customDDMinWidth ? options.customDDMinWidth : '',
          
        }, options.dropdownStyle ? options.dropdownStyle : {}]"
      >
     
      <div class="dropdown-users-toggle" v-if="options.type && options.type == 'groups-supervisor'">
        
        <div class="dropdown-users-toggle-switch">
          <ToggleButton
              :toggledState="options.showOnlyGroupUsers"
              :height="32"
              :width="64"
              :innerHeight="28"
              :innerWidth="28"
              theme="search"
              toggleDirection="right"
              @changeState="$emit('showOnlyGroupUsers', $event)"
            />
        </div>
        <span>{{toLocal('groups.show_only_group_users')}}</span>
      </div>
        <div class="search-box" :class="{active: searchTerm != ''}" v-if="options.searchBar">
          <SearchSVG v-show="searchTerm == ''" />
          <input
            :class="{ gapLeft: searchTerm == '' }"
            :placeholder="toLocal('dropdown.write')"
            v-model="searchTerm"
          />
          <span class="clear" v-if="options.clearSearch && searchTerm.length > 0" @click="searchTerm = ''">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.85348 9.14602C9.89993 9.19247 9.93678 9.24762 9.96192 9.30831C9.98706 9.36901 10 9.43406 10 9.49975C10 9.56544 9.98706 9.63049 9.96192 9.69119C9.93678 9.75188 9.89993 9.80703 9.85348 9.85348C9.80703 9.89993 9.75188 9.93678 9.69119 9.96192C9.63049 9.98706 9.56544 10 9.49975 10C9.43406 10 9.36901 9.98706 9.30831 9.96192C9.24762 9.93678 9.19247 9.89993 9.14602 9.85348L5 5.70684L0.85398 9.85348C0.760165 9.9473 0.632925 10 0.50025 10C0.367576 10 0.240335 9.9473 0.14652 9.85348C0.0527047 9.75966 2.61533e-09 9.63242 0 9.49975C-2.61533e-09 9.36707 0.0527047 9.23983 0.14652 9.14602L4.29316 5L0.14652 0.85398C0.0527047 0.760165 0 0.632925 0 0.50025C0 0.367576 0.0527047 0.240335 0.14652 0.14652C0.240335 0.0527047 0.367576 0 0.50025 0C0.632925 0 0.760165 0.0527047 0.85398 0.14652L5 4.29316L9.14602 0.14652C9.23983 0.0527047 9.36707 -2.61533e-09 9.49975 0C9.63242 2.61533e-09 9.75966 0.0527047 9.85348 0.14652C9.9473 0.240335 10 0.367576 10 0.50025C10 0.632925 9.9473 0.760165 9.85348 0.85398L5.70684 5L9.85348 9.14602Z" fill="#333333"/>
            </svg>

          </span>
        </div>
       <div
          class="options-container"
          :key="updateKey+'_tree'"
          :style="{
            maxHeight: options.customMaxHeight
              ? options.customMaxHeight
              : 'fit-content',
          }"
          v-if="options.type=='tree'"
        >
          <slot name="tree" >

          </slot>
      </div>
        <div
          class="options-container"
          :key="updateKey"
          :style="{
            maxHeight: options.customMaxHeight
              ? options.customMaxHeight
              : 'fit-content',
          }"
          v-else
        >
          <div
            class="dropdown-option all-option"
            v-if="options.selectAllChoice && options.checkbox"
            @click="selectAll()"
          >
            <div
              class="checkbox"
              v-if="options.checkbox"
              :class="{ checked: isAllChecked() }"
            >
              <CheckmarkSVG class="checkmark" v-if="isAllChecked()" />
            </div>
            <span :class="{ bold: isAllChecked() }">{{
              options.selectAllChoice
            }}</span>
          </div>
           <div
              class="options-wrapper added-users"
              v-if="options.type && options.type == 'groups-supervisor'"
            >
              <div class="row-label"> {{toLocal('groups.assigned_users')}}</div>
              <div
                class="dropdown-option"
                v-for="element in checkedItems"
                :key="`el-${element[keyLabel]}`"
                :class="[{ 
                  selected: isChecked(element[keyLabel]), 
                  'with-icon': element.icon 
                },element.class ? element.class : '',
                  element.additional ? 'additional' : ''
                ]"
                @click="clickedOnElement(element[keyLabel])"
              >
                <div
                  class="checkbox"
                  v-if="options.checkbox"
                  :class="{ checked: isChecked(element[keyLabel]) }"
                >
                  <CheckmarkSVG
                    class="checkmark"
                    v-if="isChecked(element[keyLabel])"
                  />
                </div>
                <span :class="{ bold: isChecked(element[keyLabel]) }">{{
                  toLocal(getDropdownValue(element))
                }}</span>
                <div class="right-icon" v-if="element.icon">
                  <slot :name="element.icon">
                  </slot>
                </div>
              </div>
            </div>
          <div class="options-wrapper"  v-if="options.filterType && ['date','number','percent'].includes(options.filterType)">
            <DateRangePicker
              v-if="options.filterType=='date'"
              :from="compareList[0] ? compareList[0] : ''"
              :to="compareList[1] ? compareList[1] : ''"
              @changeFrom="$emit('selectedElement', 'date', 'from', $event)"
              @changeTo="$emit('selectedElement', 'date', 'to', $event)"
              @innerPopupState="innerPopupOpen=$event"
            />
            <NumberRangePicker
              v-else-if="['number','percent'].includes(options.filterType)"
              :from="compareList[0] ? compareList[0] : ''"
              :to="compareList[1] ? compareList[1] : ''"
              :type="options.filterType"
              :rangeMin="options.rangeMin"
              :rangeMax="options.rangeMax"
              @changeFrom="$emit('selectedElement', 'number', 'from', $event)"
              @changeTo="$emit('selectedElement', 'number', 'to', $event)"
              @innerPopupState="innerPopupOpen=$event"
            />
          </div>
          <div class="options-wrapper" v-else>
            <div class="row-label" v-if="options.type && options.type == 'groups-supervisor' ">
              {{toLocal('users.unassigned_users') }}
            </div>
            <span v-if="searchTerm.length < 3 && !options.showOnlyGroupUsers && (options.type && options.type == 'groups-supervisor') " class="info-label">
              {{toLocal('groups.search_users_by_name_label')}}
            </span>
            <div class="dropdown-option-wrapper" v-else>
              <div
                class="dropdown-option"
                v-for="element in listItems"
                :key="`el-${element[keyLabel]}`"
                :class="[{ 
                  selected: isChecked(element[keyLabel]), 
                  'with-icon': element.icon 
                },element.class ? element.class : '',
                  element.additional ? 'additional' : ''
                ]"
                @click="clickedOnElement(element[keyLabel])"
              >
                <div
                  class="checkbox"
                  v-if="options.checkbox"
                  :class="{ checked: isChecked(element[keyLabel]) }"
                >
                  <CheckmarkSVG
                    class="checkmark"
                    v-if="isChecked(element[keyLabel])"
                  />
                </div>
                <span :class="{ bold: isChecked(element[keyLabel]) }">{{
                  toLocal(getDropdownValue(element))
                }}</span>
                <div class="right-icon" v-if="element.icon">
                  <slot :name="element.icon">
                  </slot>
                </div>
              </div>
            </div>
            <div class="hidden-option">
            </div>
          </div>
          
        </div>
        <div
          class="create-new"
          v-if="
            totalList.length == 0 &&
            (options.showCreateNewBtn == undefined || options.showCreateNewBtn) && options.showCreateNewBtn != false
          "
          @click="createNewElement"
        >
          <span><DropAddSVG /></span>
          <span>{{ toLocal(options.createNewText) }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CheckmarkSVG from "@/assets/images/icons/checkmark_users.svg?inline";
import ArrowDownSVG from "@/assets/images/icons/arrow-down.svg?inline";
import CrossSVG from "@/assets/images/icons/users/cross.svg?inline";
import DropAddSVG from "@/assets/images/icons/users/dropdown-add.svg?inline";
import SearchSVG from "@/assets/images/icons/users/search.svg?inline";
import FilterOnColumnsSVG from "@/assets/images/icons/users/filter_on_columns.svg?inline";
import DateRangePicker from "@/components/layout/elements/DropdownItems/DateRangePicker";
import NumberRangePicker from "@/components/layout/elements/DropdownItems/NumberRangePicker";
import ToggleButton from "@/components/layout/emails/ToggleButton.vue";

export default {
  name: "CustomDropdown",
  props: {
    list: {
      type: Array,
      default: null,
    },
    compareList: {
      type: Array,
      default: null,
    },
    compareChosen: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    keyLabel: {
      type: String,
      default: "id",
    },
    valueLabel: {
      type: String,
      default: "name",
    },
  },
  components: {
    DateRangePicker,
    NumberRangePicker,
    CheckmarkSVG,
    ArrowDownSVG,
    CrossSVG,
    DropAddSVG,
    SearchSVG,
    FilterOnColumnsSVG,
    ToggleButton,
  },
  data: function () {
    return {
      isDropdownOpen: false,
      isDropdownListOpen: false,
      showMainBorder: true,
      searchTerm: "",
      totalList: [],
      updateKey: false,
      innerPopupOpen: false,
    };
  },
  computed:{
    checkedItems(){
      return this.totalList.filter(el => this.isChecked(el[this.keyLabel]))
    },
    listItems(){
      return (this.options.type && this.options.type == 'groups-supervisor' ? this.totalList.filter(el => !this.isChecked(el[this.keyLabel])) : this.totalList)
    }
  },
  watch: {
    searchTerm: {
      handler(newVal) {
        if (!this.options.searchLocally) {
          if (newVal.length > 0) {
            this.$emit("search", newVal);
          } else {
            this.$emit("search", null);
          }
        } else {
          this.searchList(newVal);
        }
      },
    },
    list(){
      if(!(this.options.type && this.options.type == 'groups-supervisor')){
        setTimeout(() => {
          this.totalList = _.cloneDeep(this.list);
        },300)
      }
      else{
        this.searchList(this.searchTerm);
      }
    },
    isDropdownListOpen() {
      this.$emit("isDropdownListOpen", this.isDropdownListOpen);
    }
  },

  methods: {
    searchList(val) {
      let delay_time = this.options && this.options.showOnlyGroupUsers ? 0 : 300
      if (val.length > 0) {
        if(delay_time){
          setTimeout(() => {
              this.totalList = this.list.filter((listItem) => {
                if(listItem[this.valueLabel])
                  return listItem[this.valueLabel].toLowerCase().includes(val.toLowerCase());
                else return false
              });
          },delay_time)
        }
        else{
          this.totalList = this.list.filter((listItem) => {
            if(listItem[this.valueLabel])
              return listItem[this.valueLabel].toLowerCase().includes(val.toLowerCase());
            else return false
          });
        }
      } else {
        if(delay_time){
          setTimeout(() => {
            this.totalList = _.cloneDeep(this.list);
            
          },delay_time)
        }
        else{
          this.totalList = _.cloneDeep(this.list);
        
        }
      }
    },
    createNewElement() {
      if (this.searchTerm != "") {
        this.$emit("createNew", this.searchTerm);
        this.searchTerm == "";
      }
    },
    closeDropdown() {
      if(this.innerPopupOpen) return
      if (this.options.open) {
        this.$emit("close");
      } else {
        this.isDropdownListOpen = false;
        setTimeout(() => {
          this.isDropdownOpen = false;
           setTimeout(() => {
            this.showMainBorder = true;
          }, 300);
        }, 300);
      }
    },
    toggleDropdown() {
      if (this.options.open != true) {
        if(this.isDropdownOpen){
          this.isDropdownListOpen = !this.isDropdownListOpen;
          setTimeout(() => {
            this.isDropdownOpen = !this.isDropdownOpen;
            setTimeout(() => {
              this.showMainBorder = true;
            }, 300);
          }, 300);
        }
        else{
          this.isDropdownOpen = !this.isDropdownOpen;
          this.showMainBorder = false;
            setTimeout(() => {
            this.isDropdownListOpen = !this.isDropdownListOpen;
            setTimeout(() => {
              // Get dropdown element and its position
              const dropdown = this.$refs.dropdownExtended;
              if (dropdown) {
              const rect = dropdown.getBoundingClientRect();
              const bottomSpace = window.innerHeight - rect.bottom;
              // If dropdown extends beyond viewport, scroll to show it
              if (bottomSpace < 0) {
                window.scrollBy({
                top: -bottomSpace,
                behavior: 'smooth'
                });
              }
              }
            },300)
          }, 300);
        }
        
      } else {
        return;
      }
    },
    isAllChecked() {
      if (this.compareList) {
        let count = this.list.length;
        let selected = this.list.filter((lElem) => {
          if (
            this.compareList.find(
              (el) => el[this.keyLabel] == lElem[this.keyLabel]
            )
          ) {
            return lElem;
          }
        }).length;
        if (count == selected) {
          return true;
        } else {
          return false;
        }
      }
    },
    isChecked(id) {
      if (this.compareList) {
        return this.compareList.find((el) => el[this.keyLabel] == id);
      } else {
        return this.compareChosen[this.keyLabel] == id;
      }
    },
    clickedOnElement(id) {
      this.$emit("elClicked", id, this.options.attached);
      if (this.options.closeOnClick != false) {
        this.isDropdownListOpen = false;
        setTimeout(() => {
          this.isDropdownOpen = false;
          setTimeout(() => {
            this.showMainBorder = true;
          }, 300);
        }, 300);
      }
      this.updateKey = !this.updateKey;
    },
    selectAll() {
      let isAll = this.isAllChecked();
      this.updateKey = !this.updateKey;
      this.$emit("elAll", isAll, this.options.attached);
      if (this.options.closeOnClick != false) {
        this.isDropdownListOpen = false;
        setTimeout(() => {
          this.isDropdownOpen = false;
          setTimeout(() => {
            this.showMainBorder = true;
          }, 300);
        }, 300);
      }
    },
    getDropdownValue(element) {
      return element[this.valueLabel];
    },
  },
  mounted() {
    this.totalList = _.cloneDeep(this.list);
    if (this.options.open && this.options.open == true) {
      this.isDropdownOpen = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.dropdown-container {
  font-size: clamp(14px, 1.5vw, 16px);
  user-select: none;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  &:not(.no-padding-no-bg){
    padding: 4px 10px;
    background-color: #4d4d4d;
  
  }
  .whiteContrast{
    color: white;
    .dropdown-initial {
      color: white;
    }
  }
  .blackContrast{
    color: #333;
    .dropdown-initial {
      color: #333;
    }
  }
  .dropdown-initial {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    color: #333;
    span {
      max-width: 80%;
      white-space: nowrap;
      overflow-x: hidden;
      overflow-y: hidden;
      text-overflow: ellipsis;
    }
    .reverse {
      transition: 0.25s;
      transform: rotate(180deg);
    }
    .initial {
      transition: 0.25s;
      transform: rotate(0deg);
    }
    .white path {
      stroke: white;
    }
  }
  .search-box {
    padding: 10px 12px;
    display: flex;
    justify-self: center;
    align-items: center;
    position: relative;
    svg {
      position: absolute;
      left: 20px;
    }
    input {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      border: 1px solid #b2b2b2;
      padding: 4px 8px;
      &.gapLeft {
        padding-left: 28px;
      }
    }
    .clear{
     position: absolute;
      right: 18px;
      cursor: pointer;
      top: 10px;
      bottom: 0;
      margin: auto;
      display: flex;
      align-items: center;
      width: 18px;
      height: 18px;
      padding: 4px;
      svg{
        position: relative;
        left: 0;
        right: 0;
      }
    }
  }
  .dropdown-extended {
    transform-origin: top;
    position: absolute;
    top: 100%;
   
    &:not(.left){
      right: 0;
    }
    .left{
      left: 0;
    }
    z-index: 10;
    color: #333;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.24);
    &.dynamic{
      width: initial;
      .dropdown-option {
        span{
          max-width: 100%;
        }
      }
      &.left{
        left: 0;
      }
    }
    .options-container {
      max-height: 200px;
      overflow-y: auto;
    }
    .dropdown-option {
      margin: 0px 8px;
      padding: 6px 0;
      display: flex;
      gap: 8px;
      align-items: center;
      &:hover {
        font-weight: 600;
      }
      &:nth-child(1 of .additional){
          position: relative;
          // border-top: 1px solid #7D7D7D;
          &::after{
            content: '';
            top: 0;
            left: -8px;
            width: calc(100% + 16px);
            height: 1px;
            position: absolute;
            background-color: #7D7D7D;

          }
       
      }
      span {
        max-width: 80%;
        text-overflow: ellipsis;
        overflow-x: hidden;
        flex-wrap: nowrap;
        white-space: nowrap;
      }
      .checkbox {
        width: 16px;
        height: 16px;
        min-width: 16px;
        border-radius: 2px;
        border: 1px solid #4d4d4d;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        .checkmark {
          width: 100%;
          height: 100%;
          margin: 15%;
        }
        &.checked {
          background-color: var(--primary-color);
        }
      }
      .bold {
        font-weight: 600;
      }
      &.with-icon{
        justify-content: space-between;
      }
      
    }
    .all-option {
      border-bottom: 1px solid black;
    }
  }
}
.dropdown-users-toggle{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.75rem 0.75rem 0.5rem;
}
.dropdown-header-container{
  position: absolute;
  top: 0;
  right: 0;
  // padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #B2B2B2;
  background: white;
  width: 100%;
  z-index: 11;
  min-height: 32px;
  width: calc(100% + 5rem);
  &.closing{
    z-index: 10 !important;
  }
}
.supervisor-dropdown{
  transition: border 0.3s ease;
  min-height: 32px;
  // z-index: 12;
  &:not(.no-padding-no-bg){
        padding: 0;
    }
  .dropdown-initial:not(.no-padding-no-bg){
    padding: 4px 10px;
  }
  .search-box{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  &.open{
    border: 1px solid transparent;
    // z-index: 13;
    .dropdown-extended{
      width: calc(100% + 5rem);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      z-index: 12;
    }
    .options-container{
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      padding: 0.5rem 0.75rem;
      .dropdown-option{
        margin: 0;
      }
      .row-label{
        text-align: left;
        font-weight: 600;
      }
    }
     .dropdown-extended .dropdown-option .checkbox.checked{
      background-color: transparent;
    }
    .dropdown-header-container{
      z-index: 13;
    }
  }
  .options-container{
    width: 100%;
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0%);
  overflow: visible;
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  z-index: 1;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  height: 32px;
  width: 100%;
}
.slide-leave-to{
  
}

.closeBtn {
  svg path {
    fill: white;
  }
}
.create-new {
  border-top: 1px solid #b2b2b2;
  margin: 0px 10px;
  display: flex;
  align-items: center;
  padding: 6px 0;
  gap: 8px;
  &:hover {
    span {
      svg {
        box-sizing: content-box;
        border-radius: 50%;
        fill: var(--secondary-color);
        circle {
          fill: var(--secondary-color);
          stroke: #4d4d4d;
        }
      }
    }
  }
  span {
    display: flex;
    align-items: center;
  }
}

.options-wrapper{
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss">
.dropdown-btn-icon{
  display: flex;
  justify-content: center;
  align-items: center;
  &.active{
    background: #F4F4F4;
    border-radius: 50%;
    svg{
      path{
        fill: #4D4D4D;
      }
    }
  }
}
.options-container{
  .dropdown-option{
    .right-icon{
      svg{
        path{
          fill: #333;
        }
      }
    }
    &.danger{
      color:#D45454;
      .right-icon{
        svg{
          path{
            fill: #D45454;
          }
        }
      }
    }
  }
}
.info-label{
  color: #7D7D7D;
  font-size: 14px;
  text-align: left;
  margin-top: 5px;
}
.leader-page-dropdown.tree-dropdown{
  .search-box.active{
      input{
        border: initial;
        background-color: #FFFFFF;
        outline: 1px solid #B2B2B2;
      }
  }
  input{
    background-color: #F4F4F4;
    border: none;
    &:focus{
      border: initial;
      background-color: #FFFFFF;
      outline: 1px solid #B2B2B2;
    }
    
   
  }
  .search-box{
    padding-bottom: 0;
  }
}
</style>